import { render, staticRenderFns } from "./RePassportFull.vue?vue&type=template&id=208de35c&scoped=true"
import script from "./RePassportFull.vue?vue&type=script&lang=js"
export * from "./RePassportFull.vue?vue&type=script&lang=js"
import style0 from "./RePassportFull.vue?vue&type=style&index=0&id=208de35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208de35c",
  null
  
)

export default component.exports